import React, { useMemo } from "react";
import { PuceContext } from "context/AppContext";
import { useLocation } from "react-router-dom";
import BackButton from "components/BackButton";
import servicesAPI from "services/servicesAPI";
import LoadComponent from "components/LoadComponent";
import ModuleTitle from "components/ModuleTitle";
import { Grid } from "@mui/material";
import PuceDetails from "./components/PuceDetails";
import PuceLogs from "./components/PuceLog";

function DetailPuce() {
  const { state } = useLocation();
  const { selectedData } = state;
  const { isAlert, isLoading, message, alertSeverity, handleLoad, getData, putData, postData } =
    servicesAPI();

  const loadDataConfig = useMemo(() => {
    const value = {
      isAlert,
      isLoading,
      message,
      alertSeverity,
      handleLoad,
    };
    return value;
  }, [isAlert, isLoading, message, alertSeverity]);
  const propsDataConfig = useMemo(() => {
    const value = {
      selectedData,
      // title: `${selectedData?.isTranshumance ? "Transhumant" : ""}`,
      ApiService: { getData, putData, postData, handleLoad },
    };
    return value;
  }, [selectedData]);

  return (
    <>
      <ModuleTitle title="Informations de la puce" />
      <BackButton />

      <PuceContext.Provider value={propsDataConfig}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PuceDetails />
          </Grid>

          <Grid item xs={12}>
            <PuceLogs numero={selectedData?.numero} ApiService={{ getData, handleLoad }} />
          </Grid>
        </Grid>
      </PuceContext.Provider>
      <LoadComponent loadData={loadDataConfig} />
    </>
  );
}

export default DetailPuce;
